module.exports = __webpack_public_path__ + "static/media/pdf.5176ce42.svg";